import { Container } from "@mui/material"
import Grid from "@mui/material/Grid"
import { useParams } from "react-router-dom"
import { CustomerEditPageAddress } from "./CustomerEditPageAddress"
import { CustomerEditPageBaseData } from "./CustomerEditPageBaseData"
import { CustomerEditPageOrders } from "./CustomerEditPageOrders"
import CustomerDebit from "pages/CustomerDebit/CustomerDebit"

const CustomerEditPage = () => {
  const { customerID } = useParams()

  return (
    <>
      {customerID !== undefined && (
        <Container maxWidth={false}>
          <Grid container spacing={2}>
            <Grid size={12}>
              <CustomerEditPageBaseData customerID={customerID} />
            </Grid>
            <Grid size={12}>
              <CustomerEditPageOrders customerID={customerID} addOrder={true} />
            </Grid>
            <Grid size={12}>
              <CustomerEditPageAddress customerID={customerID} open={false} />
            </Grid>
            <Grid sx={{ marginBottom: 2 }} size={12}>
              <CustomerDebit customerID={customerID} />
            </Grid>
          </Grid>
        </Container>
      )}
    </>
  )
}

export default CustomerEditPage
